export const getDefaultParams = reportParams => reportParams && reportParams.reduce((seed, param) => {
  if (param.defaultValue) {
    seed[param.apiParam] = param.defaultValue;
  }

  return seed;
}, {});